import { createSelector } from '@reduxjs/toolkit';
import { getCatalog } from './catalog/catalog.selectors';
import { getLiveCatalogData } from './console';
import { getSeller } from './seller';
import { getSellerCatalogCounts } from './sellerCatalogCounts';
import { getSellerPreviewCatalogs } from './sellerPreviewCatalogs';
import { GlobalState } from '../rootReducer';

const globalStateSelector = (state: GlobalState) => state;
const idSelector = (state: GlobalState, id) => id;

const getCatalogCardData: (state: any, selector: any) => any = createSelector(
    [globalStateSelector, idSelector],
    (state, catalogId) => {
        const catalog = getCatalog(state, catalogId);
        const seller = getSeller(state, catalog.sellerId);
        return { catalog, seller };
    }
);

export const getCatalogCardDatas = createSelector([globalStateSelector, idSelector], (state, catalogIds) =>
    catalogIds.map((id) => getCatalogCardData(state, id))
);

const getLiveCatalogCardData = createSelector([globalStateSelector, idSelector], (state, catalogId) => {
    const { bidders } = getLiveCatalogData(state, catalogId);
    return {
        ...getCatalogCardData(state, catalogId),
        bidders,
    };
});

export const getLiveCatalogCardDatas = createSelector([globalStateSelector, idSelector], (state, catalogIds) => {
    return catalogIds.map((id) => getLiveCatalogCardData(state, id));
});

export const getPreviewCatalogCardsData: (state: any, selector: any) => any = createSelector(
    [globalStateSelector, idSelector],
    (state, sellerId) => {
        const seller = getSeller(state, sellerId);
        return getSellerPreviewCatalogs(state, sellerId)
            .map((catalogPreview) => {
                return { catalogPreview, seller };
            })
            .sort((a, b) => {
                return a.catalogPreview.saleStartTs - b.catalogPreview.saleStartTs;
            });
    }
);

const getSellerCardData = createSelector([globalStateSelector, idSelector], (state, sellerId) => {
    const seller = getSeller(state, sellerId);
    const catalogCounts = getSellerCatalogCounts(state, sellerId);
    return { catalogCounts, seller };
});

export const getSellerCardDatas: (state: any, selector: any) => any = createSelector(
    [globalStateSelector, idSelector],
    (state, sellerIds) => sellerIds.map((id) => getSellerCardData(state, id))
);
